import React, {memo, useMemo} from 'react';
import {Col, Row} from 'components/Grid';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import Picture from 'components/Picture';
import {CollapseText} from 'components/CollapseText';
import {IBrand} from 'modules/brands/models';
import {getMediaSrc} from 'core/helpers/media';

type TBrandXAboutProps = Pick<IBrand, 'title' | 'description' | 'logo'>;

export const BrandXAbout = memo<TBrandXAboutProps>(({title, description, logo}) => {
    const htmlText = useMemo(() => {
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        return {__html: description ?? ''};
    }, [description]);
    return (
        <Row>
            <Col className={style.aboutWrap} lg={9} md={12} sm={12}>
                <div className={style.about}>
                    <div className={style.leftBlock}>
                        <span className={style.line} />
                        <Typography className={style.title} element={'h1'} variant={'display-42-reg'}>
                            {title}
                        </Typography>
                        <div className={style.description}>
                            <Typography
                                className={style.textDesktop}
                                dangerouslySetInnerHTML={htmlText}
                                element={'p'}
                                variant={'h3'}
                            />
                            <div className={style.textMobile}>
                                <CollapseText>
                                    <Typography dangerouslySetInnerHTML={htmlText} element={'p'} variant={'p'} />
                                </CollapseText>
                            </div>
                        </div>
                    </div>
                    <div className={style.logo}>
                        <Picture sources={{}} src={getMediaSrc(logo?.url, {isWebp: true, width: 430})} />
                    </div>
                </div>
            </Col>
        </Row>
    );
});
